import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

import { computed, watch } from "vue";
import { KeenSliderInstance } from "keen-slider";
import { useKeenSlider } from "keen-slider/vue.es";
import BonusomatOnboardingPage from "./bonusomat-onboarding-page.vue";

import useBonusomatOnboarding from "../../composables/use-bonusomat-onboarding";


export default /*@__PURE__*/_defineComponent({
  __name: 'bonusomat-onboarding-carousel',
  setup(__props) {

const { onboardingData, onboardingActiveStep, onboardingActiveStepChangedWatch } = useBonusomatOnboarding();

const onboardingPages = computed(() => onboardingData.value?.pages);

const [sliderContainer, slider] = useKeenSlider<HTMLDivElement>({
    selector: ".bonusomat-onboarding-page__device",
    slides: {
        perView: 1,
    },
    slideChanged: (s: KeenSliderInstance) => {
        onboardingActiveStep.value = s.track.details.abs;
    },
    initial: onboardingActiveStep.value,
});

// We can't watch directly the 'onboardingActiveStep' because it can be changed by KeenSlider itself (e.g. when swiping) what causes double move
watch(onboardingActiveStepChangedWatch, () => {
    slider.value.moveToIdx(onboardingActiveStep.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bonusomat-onboarding__carousel", 'bonusomat-onboarding__carousel--step-' + _unref(onboardingActiveStep)]),
    ref_key: "sliderContainer",
    ref: sliderContainer
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(onboardingPages.value, (page) => {
      return (_openBlock(), _createBlock(BonusomatOnboardingPage, _mergeProps({
        key: page.codeName
      }, { ref_for: true }, page), null, 16))
    }), 128))
  ], 2))
}
}

})